<template>
  <form class="form-horizontal">
    <card>
      <div slot="header">
        <h4 class="card-title">{{ crud }} Usuário</h4>
      </div>
      <div>
        <fg-input
          v-if="this.crud === 'Criar'"
          name="username"
          label="Apelido"
        >
          <el-input
            type="text"
            placeholder="Username"
            v-model="model.username"
          ></el-input>
        </fg-input>

        <fg-input
          name="name"
          label="Nome"
        >
          <el-input
            type="text"
            placeholder="Nome"
            v-model="model.first_name"
          ></el-input>
        </fg-input>

        <fg-input
          name="last_name"
          label="Sobrenome"
        >
          <el-input
            type="text"
            placeholder="Sobrenome"
            v-model="model.last_name"
          ></el-input>
        </fg-input>

        <fg-input
          name="email"
          label="Email"
        >
          <el-input
            type="text"
            placeholder="E-mail"
            v-model="model.email"
          ></el-input>
        </fg-input>


        <fg-input
          v-if="this.crud === 'Criar'"
          name="password "
          label="Senha"
        >
          <el-input
            type="text"
            placeholder="Senha"
            v-model="model.password"
          ></el-input>
        </fg-input>

        <fg-input v-if="$store.state.auth.smartmach == 'true' || showMatriz" name="company" label="Empresa">
          <el-select
            class
            size="large"
            style="width: 100%"
            placeholder="Selecione a empresa dos usuários"
            v-model="model.profile.company"
          >
            <el-option
              v-for="option in companyList"
              class
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </fg-input>
          
          <fg-input
            name="Matriz"
            v-if="showItem"
            label="Empresa Matriz">

            <el-select class=""
                        size="large"
                        style="width: 100%"
                        placeholder="Selecione a empresa Matriz"
                        v-model="model.profile.parent_company">
              <el-option v-for="option in $store.state.parent.matrizes"
                          class=""
                          :value="option.id"
                          :label="option.name"
                          :key="option.id">
              </el-option>
            </el-select>
          </fg-input>


        <!-- <fg-input name="Permission" label="Permissão" v-if="model.profile.company && this.crud === 'Criar'">
          <el-select
            class
            size="large"
            style="width: 100%"
            placeholder="Selecione um grupo de permissões"
            value-key='id'
            v-model="permissionGroup"
          >
            <el-option
              v-for="option in permissionList"
              :value="option"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </fg-input> -->

        <fg-input name="smartmach" label="Usuário SmartMach" v-if="$store.state.auth.smartmach === 'true'">
          <div>
            <l-switch v-model="model.profile.is_smartmach"></l-switch>
          </div>
        </fg-input>
      </div>
    </card>
    <card>
      <div>
        <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info btn-wd">Salvar</button>
      </div>
    </card>
  </form>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { Switch as LSwitch } from "src/components/index";
import swal from "sweetalert2";
export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Option.name]: Option,
    [Select.name]: Select,
    LSwitch
  },
  mounted() {
    this.$store.dispatch("parent/list").catch(err => console.log(err))
    if (this.$route.params.id) {
      this.$store.dispatch("users/get", {id: this.$route.params.id}).then(data => {
        this.model = data
      });
      this.crud = "Editar";
    } else {
      this.crud = "Criar";
    }
    this.$watch('model.profile.company', () =>{
      this.getPermissionGroup()
    })
    if (this.$store.state.auth.smartmach === 'true') {
      this.getListCompany();
    } else {
      this.model.profile.company =  this.$store.state.auth.company
    }
  },
  computed: {
    showItem() {
      this.parentCompany = localStorage.getItem("parent_company")
      const smartmach = localStorage.getItem("smartmach")
      if (smartmach == 'true') {
        return true
      } else if (localStorage.getItem("parent_company") != 'null') {
        return true
      } else {
        return false
      }
    },
  },
  data() {
    return {
      crud: "Editar",
      imagesAPI: [],
      images: [],
      showImage: true,
      permissionGroup: [],
      permissionList: [],
      // imageKey: 0,
      model: {
        username: "",
        first_name: "",
        last_name: "",
        email: "",
        smartmach: false,
        company: '',
        is_staff: true,
        is_active: true,
        profile: {
          "is_smartmach": false,
          "company": '',
          "is_vm": false,
          "is_maintainer": false,
          "is_admin": false,
          "dismiss_new_product_dialog": false,
          "parent_company": null
        }
          
      },
      companyList: [],
      modelValidations: {
        name: {
          required: true
        }
      }
    };
  },
  methods: {
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>Item Salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    // getListCompany() {
    //   this.$store.dispatch("general/listUser").then(() => {
    //     var x = this.$store.state.general.listUser.user_list_info;
    //     this.companyList = x.filter(
    //       (thing, index, self) =>
    //         index ===
    //         self.findIndex(
    //           t =>
    //             t.profile__company__id === thing.profile__company__id &&
    //             t.profile__company__name === thing.profile__company__name
    //         )
    //     );
    //   })
    // },
    getListCompany() {
      this.$store.dispatch("company/list").then(data => {
        console.log('data', data)
       this.companyList = data
      })
    },
    getPermissionGroup () {
      this.permissionList = []
      this.permissionGroup = []
      if (!this.showMatriz) {
        this.$store.dispatch('general/groupCompany', { search: '?company_id=' + this.model.profile.company}).then(data =>{
          this.permissionList = data
          console.log('permissionList', this.permissionList)
        })
      }
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        if (isValid && this.crud === "Criar") {
          if (this.model.profile.parent_company === '') {
            this.model.profile.parent_company = null
          }
          this.$store
            .dispatch("users/create", { item: this.model })
            .then(data => {
              // console.log('data resp', data)
              // this.permissionGroup.users.push(data.id)
              // this.permissionGroup.company_id = this.permissionGroup.company.id
              // this.permissionGroup.custom_permissions_id = []
              // for (let index = 0; index < this.permissionGroup.custom_permissions.length; index++) {
              //   this.permissionGroup.custom_permissions_id.push(this.permissionGroup.custom_permissions[index].id)
              // }
              // this.$store.dispatch("general/update", { item: this.permissionGroup }).then(resp => {
                this.notifySuccess();
                this.$router.push(`/app/users`);
              // })
            });
        } else if (isValid && this.crud === "Editar") {
          this.$store
            .dispatch("users/update", { item: this.model })
            .then(data => {
              // this.permissionGroup.users.push(data.id)
              // this.permissionGroup.company_id = this.permissionGroup.company.id
              // this.permissionGroup.custom_permissions_id = []
              // for (let index = 0; index < this.permissionGroup.custom_permissions.length; index++) {
              //   this.permissionGroup.custom_permissions_id.push(this.permissionGroup.custom_permissions[index].id)
              // }
              // this.$store.dispatch("general/update", { item: this.permissionGroup }).then(resp => {
                this.notifySuccess();
                this.$router.push(`/app/users`);
              // })
            });
        }
      });
    }
  }
};
</script>
<style scoped>
.el-select {
  margin-bottom: 10px;
}
img {
  width: 200px;
}
.img-upload {
  border: 1px solid #ccc;
  border-radius: 5px;
  display: inline-block;
  padding: 10px;
  margin-bottom: 20px;
}
</style>
